module.exports = __webpack_public_path__ + "img/logo-isii-nitzan.5ffc4751.png";